import { Avatar, Flexbox } from '@/components'
import { singularStatusMapLabel as castrationStatusMap, textClasses as castrationTextClasses } from '@/constants/castration'
import { clinicalCareStatus, clinicalCareStatusClasses } from '@/constants/clinicalCares'
import dateMask from '@/lib/masks/date'
import PropTypes from 'prop-types'
import React from 'react'
import { Link } from 'react-router-dom'

const statusMaps = {
  castration: castrationStatusMap,
  clinicalCare: clinicalCareStatus,
}

const statusTextClasses = {
  castration: castrationTextClasses,
  clinicalCare: clinicalCareStatusClasses,
}

function messagePreview(message) {
  const description = message?.description || ''
  return description.length > 60 ? `${description.substring(0, 60)}...` : description
}

function hasAttachment(message) {
  return Boolean(message?.attachmentURL || message?.images?.length || message?.images)
}

function conversationStatus(conversation) {
  const status = conversation?.status
  return statusMaps[conversation?.type]?.[status] || status
}

function statusClassName(conversation) {
  return statusTextClasses[conversation?.type]?.[conversation?.status] || ''
}

function resourcePath(conversation) {
  if (conversation?.type === 'castration') {
    return `/app/castrations/status/${conversation.status}/${conversation.resourceId}`
  }

  if (conversation?.type === 'clinicalCare') {
    return `/app/clinical-cares/status/${conversation.status}/${conversation.resourceId}`
  }

  return null
}

function conversationPath(conversation, basePath) {
  return `${basePath}/${conversation.conversationId}`
}

function Row({ conversation, basePath, search }) {
  return (
    <tr className={conversation.unreads > 0 ? 'text-bold' : ''}>
      <td>
        <Flexbox.Columns className="align-center col-gapless">
          <Flexbox.Column className="col-auto">
            <Avatar
              className="mr-1"
              name={conversation?.animal?.name || conversation?.title}
              photoURL={conversation?.animal?.photoURL}
              smart={false}
              alt="Imagem da conversa"
            />
          </Flexbox.Column>
          <Flexbox.Column className="ml-1">
            <div>
              {
                resourcePath(conversation)
                  ? (
                    <Link to={resourcePath(conversation)}>
                      {conversation?.title}
                    </Link>
                  )
                  : conversation?.title
              }
            </div>
          </Flexbox.Column>
        </Flexbox.Columns>
      </td>
      <td>
        <Flexbox.Columns className="align-center col-gapless">
          <Flexbox.Column className="col-auto">
            <Avatar
              className="mr-1"
              name={conversation?.lastMessage?.author?.fullName}
              photoURL={conversation?.lastMessage?.author?.photoURL}
              alt="Imagem do autor"
            />
          </Flexbox.Column>
          <Flexbox.Column className="ml-1">
            <div>
              <span>{conversation?.lastMessage?.author?.fullName}</span>
              {
                conversation.unreads > 0 && (
                  <span className="badge ml-2" data-badge={conversation.unreads} />
                )
              }
            </div>
            <small>
              {messagePreview(conversation?.lastMessage)}
              {
                hasAttachment(conversation?.lastMessage)
                  ? <><i className="fas fa-image ml-1" />&nbsp;Imagem</>
                  : null
              }
            </small>
            <div>
              <small>{dateMask(conversation?.lastMessage?.createdAt)}</small>
            </div>
          </Flexbox.Column>
        </Flexbox.Columns>
      </td>
      <td>
        {
          conversation?.participants?.map((person) => (
            <div key={person.id}>
              <Avatar
                avatarSize="xs"
                className="mr-1"
                name={person?.fullName}
                photoURL={person?.photoURL}
                alt="Imagem do participante"
              />
              {person?.fullName}
            </div>
          ))
        }
      </td>
      <td className={statusClassName(conversation)}>
        {conversationStatus(conversation)}
      </td>
      <td>
        <div className="d-flex align-center" style={{ justifyContent: 'flex-end' }}>
          <Link
            to={{
              pathname: conversationPath(conversation, basePath),
              search,
              state: { conversation },
            }}
            className="btn btn-action btn-sm btn-primary"
          >
            <i className="fas fa-eye" />
          </Link>
        </div>
      </td>
    </tr>
  )
}

Row.propTypes = {
  conversation: PropTypes.objectOf(PropTypes.any).isRequired,
  basePath: PropTypes.string.isRequired,
  search: PropTypes.string.isRequired,
}

export default Row
